var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserPunkte(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.1 22.1",
    style: {
      enableBackground: "new 0 0 22.1 22.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#61686F;}\n\t.st2{fill:none;stroke:#61686F;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#61686F;stroke:#62686F;stroke-width:0.2;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_profile_00000183934034297977937090000015175404168217502082_",
    transform: "translate(-492 -375.586)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319_00000005269106803531356590000009741741024859244190_",
    x: 499.7,
    y: 387,
    className: "st0",
    width: 9.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Account_00000168798576674709137390000009030416939144679811_",
    transform: "translate(-4508.75 -342.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53_00000013187245215872631490000018182191167884780204_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5013.3,731.9c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2c-1.1,0-2-0.9-2-2C5011.3,732.7,5012.2,731.8,5013.3,731.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_641_00000005953380886280348980000013084367818895203457_",
    className: "st1",
    d: "M5016.6,738.4h-6.5 c0-1.2,1.1-2.2,2.5-2.2h1.5C5015.5,736.2,5016.6,737.2,5016.6,738.4L5016.6,738.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.3,7.9c0-1.8-1.6-3.3-3.5-3.3c-2,0-3.5,1.5-3.5,3.3c0,1.8,1.6,3.3,3.5,3.3C8.7,11.2,10.3,9.7,10.3,7.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "11.7,7.9 12.4,6.7 11.2,5.9 11.3,4.5 9.8,4.3 9.3,3 7.8,3.4 6.7,2.4 5.6,3.4 4.2,3 3.7,4.3 2.2,4.5  2.3,5.9 1.1,6.7 1.8,7.9 1.1,9.1 2.3,9.9 2.2,11.2 3.7,11.5 4.2,12.8 5.6,12.4 6.7,13.3 7.8,12.4 9.3,12.8 9.8,11.5 11.3,11.2  11.2,9.9 12.4,9.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M4.9,6.6h1v2.8H5.6V6.8H4.9V6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M8.6,6.9c0.2,0.2,0.3,0.6,0.3,1c0,0.5-0.1,0.8-0.3,1C8.4,9.3,8.1,9.4,7.7,9.4C7.3,9.4,7,9.3,6.8,9 C6.6,8.8,6.5,8.4,6.5,8c0-0.5,0.1-0.8,0.3-1C7,6.7,7.3,6.6,7.7,6.6C8.1,6.6,8.4,6.7,8.6,6.9z M7,7.1C6.9,7.3,6.8,7.6,6.8,8 c0,0.4,0.1,0.7,0.2,0.9c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3C8.6,8.7,8.6,8.4,8.6,8c0-0.4-0.1-0.7-0.2-0.9 C8.2,6.9,8,6.8,7.7,6.8C7.4,6.8,7.2,6.9,7,7.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon_profile_00000164512360576564094650000009147495936532825219_",
    transform: "translate(-492 -375.586)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319_00000161615157659997583970000015199913481213384597_",
    x: 507.9,
    y: 386.8,
    className: "st0",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Account_00000115497111701260160630000004284769410111963284_",
    transform: "translate(-4508.75 -342.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53_00000144306032836309169590000009090102608779788717_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5019.6,730.9c0.7,0,1.2,0.5,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.5-1.2-1.2 C5018.3,731.4,5018.9,730.9,5019.6,730.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_641_00000121247127459275780560000018157872323872364732_",
    className: "st1",
    d: "M5021.6,734.9h-4c0-0.7,0.7-1.3,1.6-1.3 h0.9C5020.9,733.5,5021.6,734.1,5021.6,734.9L5021.6,734.9z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "icon_profile_00000004507800921203161830000004013042400636748436_",
    transform: "translate(-492 -375.586)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319_00000168087225729194211050000009230582284451998344_",
    x: 504.6,
    y: 383.6,
    className: "st0",
    width: 4.8,
    height: 4.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Account_00000010309594633055321320000004396394429885792435_",
    transform: "translate(-4508.75 -342.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53_00000036952017856598059220000013116553021701652142_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5015.7,727.4c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1C5014.8,727.8,5015.2,727.4,5015.7,727.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_641_00000088844151592390011740000008894439837747794877_",
    className: "st1",
    d: "M5017.3,730.5h-3.2 c0-0.6,0.6-1.1,1.2-1.1h0.7C5016.8,729.5,5017.3,730,5017.3,730.5L5017.3,730.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPunkte);
export default __webpack_public_path__ + "static/media/user_punkte.d1761362999ae8d717d24ac9e23bc5ea.svg";
export { ForwardRef as ReactComponent };